import React, { useState } from "react";
import {
  EditableTextField,
  EditableSelectField,
  RadioOptions,

} from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload,CustomFileUploadLikeSelect } from "../../../../Global_Component/customFileUplodComponent";
import OPTIONS from "../../../../constant/Option";
import { Box, Grid, Typography,Button } from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

const RawMaterialListing = () => {
  const [noOfProduct, setNoOfProduct] = useState([
    "SL NO 1",
    "SL NO 2",
    
   
   
  ]);

  function addMoreProduct() {
    setNoOfProduct([...noOfProduct, `SL No ${noOfProduct.length + 1}`]);
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
      
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "auto",
      
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Raw Material Listing
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          
         
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          {noOfProduct.map((data, index) => (
            <Grid
              container
              key={index}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                >
                  {data}
                </Typography>
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="name"
                  label="Raw Material Name"
                  value=""
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="category"
                  label="Category"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="Usage"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>



              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="Brand Name"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="ManufactureBy"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <CustomFileUploadLikeSelect
                  name="usage"
                  label="Bill Upload"
                  value=""
                  onChange={e=>{}}
                  
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Grid
        xs={12}
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-stat",
          gap: 1,
          borderTop: "1px solid gray",
        }}
      >
        <Grid md={"10"}>
            <Button onClick={addMoreProduct}>Add more Product</Button>
        </Grid>
        <Grid md={"12"} sx={{ display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          }}>
        <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
        <CustomSuccessButton label={"Next"} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RawMaterialListing;
